<template>
  <div class="SearchPage">
    <div
    class="SearchPage__scrollable scrollbar-container"
    id="SearchPageScrollable">
        <div
        v-if="empty"
        class="SearchPage__empty">
          <div class="SearchPage__empty-center">
            <SvgImage
            imageName="SearchMagnifier"
            class="SearchPage__empty-image"/>
            <span class="SearchPage__empty-text">
              No search results
            </span>
          </div>
        </div>
        <FileBar
        v-for="file in searchFiles"
        :key="file.id"
        :file="file"
        class="SearchPage__element"/>
        <InViewportContainer
        v-if="hasNextToken"
        container-id="SearchPageScrollable"
        :handler="fetchSearchResults"
        class="SearchPage__load-more">
          <i class="el-icon-loading SearchPage__load-icon"/>
        </InViewportContainer>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'

import FileBar from '@/components/file/bar/FileBar'

export default {
  name: 'SearchPage',

  components: {
    FileBar
  },
  data () {
    return {
      loading: true,
      nextToken: undefined
    }
  },

  computed: {
    ...mapGetters('search', [
      'searchFiles'
    ]),
    searchString () {
      return decodeURIComponent(this.$route.params.searchString)
    },
    hasNextToken () {
      return !!this.nextToken
    },
    empty () {
      return !this.searchFiles.length && !this.loading
    }
  },

  watch: {
    searchString (string) {
      this.setSearchFiles([])
      this.nextToken = undefined
      this.fetchSearchResults(string)
    }
  },

  mounted () {
    this.fetchSearchResults(this.searchString)
  },

  beforeDestroy () {
    this.setSearchFiles([])
  },

  methods: {
    ...mapActions('search', [
      'getSearchResults',
      'setSearchFiles'
    ]),
    fetchSearchResults (string = this.searchString) {
      if (this.searchFiles.length && !this.nextToken) return

      this.loading = true
      const params = {
        searchPhrase: string,
        nextToken: this.nextToken
      }
      this.getSearchResults(params)
        .then(({ items, nextToken }) => {
          this.nextToken = nextToken
          this.setSearchFiles(items)
          this.loading = false
        }).catch(() => {})
    }
  }
}
</script>

<style lang="scss">
@import 'SearchPage';
</style>
